import React from 'react';
import { Search, ShoppingCart, HelpCircle } from 'lucide-react';
export function Header() {
  return <header className="bg-white border-b border-brand-border sticky top-0 z-40 shadow-sm" data-id="element-549">
      <div className="max-w-7xl mx-auto px-4 py-2 lg:py-2.5" data-id="element-550">
        <div className="flex items-center justify-between gap-4 lg:gap-8" data-id="element-551">
          {/* Logo */}
          <a href="/Home.html" className="flex-shrink-0 -my-1" aria-label="MidAtlantic Mailbox home" data-id="element-552">
            <img src="https://www.midatlanticmailboxes.com/uploaded/images/Redesign/Logo%201.png" alt="MidAtlantic Mailboxes Logo" className="h-12 lg:h-16 w-auto object-contain" data-id="element-553" />
          </a>

          {/* Desktop Search */}
          <div className="hidden lg:flex flex-1 max-w-2xl" data-id="element-554">
            {/* TODO: wire form action to Website Forge search endpoint */}
            <form className="relative w-full group" role="search" onSubmit={e => e.preventDefault()} data-id="element-555">
              <input type="text" aria-label="Search products, brands, parts, or specs" placeholder="Search products, brands, parts, or specs" className="w-full pl-4 pr-12 py-2.5 rounded-md border border-brand-border bg-brand-cream focus:bg-white focus:border-brand-maroon focus:outline-none focus:ring-1 focus:ring-brand-maroon transition-all text-brand-charcoal placeholder-gray-500 font-medium group-hover:border-gray-300" data-id="element-556" />
              <button type="submit" aria-label="Search" className="absolute right-1.5 top-1/2 -translate-y-1/2 p-1.5 bg-brand-charcoal text-white rounded hover:bg-brand-charcoal/90 transition-colors" data-id="element-557">
                <Search size={18} data-id="element-558" />
              </button>
            </form>
          </div>

          {/* Desktop Actions */}
          <div className="hidden lg:flex items-center gap-6" data-id="element-559">
            <a href="/ContactUs.html" className="flex items-center gap-2 text-brand-charcoal hover:text-brand-maroon font-medium transition-colors" data-id="element-560">
              <HelpCircle size={18} className="text-brand-maroon" data-id="element-561" />
              <span data-id="element-562">Help Choosing</span>
            </a>

            {/* TODO: wire to verified Website Forge cart/checkout path */}
            <button type="button" aria-label="Cart (Website Forge integration pending)" data-wf-cart-todo="true" className="flex items-center gap-2 bg-white px-4 py-2 rounded-md border border-brand-border hover:border-brand-maroon hover:bg-brand-panel transition-colors font-medium" data-id="element-563">
              <ShoppingCart size={18} className="text-brand-charcoal" data-id="element-564" />
              <span data-id="element-565">Cart $0.00</span>
            </button>
          </div>

          {/* Mobile Cart */}
          <div className="lg:hidden flex items-center" data-id="element-566">
            {/* TODO: wire to verified Website Forge cart/checkout path */}
            <button type="button" aria-label="Cart (Website Forge integration pending)" data-wf-cart-todo="true" className="relative p-2 text-brand-charcoal hover:text-brand-maroon transition-colors" data-id="element-567">
              <ShoppingCart size={24} data-id="element-568" />
              <span className="absolute top-0 right-0 bg-brand-maroon text-white text-[10px] font-bold h-4 w-4 rounded-full flex items-center justify-center" data-id="element-569">
                0
              </span>
            </button>
          </div>
        </div>

        {/* Mobile Search (Below Header) */}
        <div className="mt-3 lg:hidden" data-id="element-570">
          {/* TODO: wire form action to Website Forge search endpoint */}
          <form className="relative w-full" role="search" onSubmit={e => e.preventDefault()} data-id="element-571">
            <input id="mobile-search" type="text" aria-label="Search products, brands, parts" placeholder="Search products, brands, parts..." className="w-full pl-4 pr-12 py-2.5 rounded-md border border-brand-border bg-brand-cream focus:bg-white focus:border-brand-maroon focus:outline-none text-brand-charcoal font-medium" data-id="element-572" />
            <button type="submit" aria-label="Search" className="absolute right-1.5 top-1/2 -translate-y-1/2 p-1.5 bg-brand-charcoal text-white rounded" data-id="element-573">
              <Search size={16} data-id="element-574" />
            </button>
          </form>
        </div>
      </div>
    </header>;
}